export const VISION_BUTTONS = [ 
  {
    value: 'blurred',
    label: 'Blurred vision',
    moreInfo: ''
  },
  {
    value: 'cvi',
    label: 'Cortical visual impairment',
    moreInfo: ''
  },
  {
    value: 'double',
    label: 'Double vision',
    moreInfo: ''
  },
  {
    value: 'field-cut',
    label: 'Field cut',
    moreInfo: ''
  },
  {
    value: 'tracking',
    label: 'Tracking problems',
    moreInfo: ''
  },
  {
    value: 'other',
    label: 'Other',
    moreInfo: ''
  }
];

export function getVisionLabelForValue(value){
  const allBtns = VISION_BUTTONS;
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  if (matchingBtn)
    return matchingBtn.label;
  else
    return ""; //no match found
}


